<h1>{{ trainerName }} dokumentumai</h1>
<app-documents
  [entityId]="trainerId"
  [documentTypes]="documentTypes"
  [allDocuments]="allDocuments"
  storageCollectionName="trainers"
  (onRefresh)="refreshDocuments()"
></app-documents>
